import { genComponentStyleHook } from '../../theme';
import genSpaceCompactStyle from './compact';
const genSpaceStyle = (token) => {
    const { componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl',
            },
            '&-vertical': {
                flexDirection: 'column',
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center',
                },
                '&-start': {
                    alignItems: 'flex-start',
                },
                '&-end': {
                    alignItems: 'flex-end',
                },
                '&-baseline': {
                    alignItems: 'flex-baseline',
                },
            },
            [`${componentCls}-space-item`]: {
                '&:empty': {
                    display: 'none',
                },
            },
        },
    };
};
// ============================== Export ==============================
export default genComponentStyleHook('Space', (token) => [
    genSpaceStyle(token),
    genSpaceCompactStyle(token),
]);
